<template>
  <div class="lr-intent-popup">
    <div class="popup-container">
      <div class="intent-close">
        <button type="button" data-close @click="decline">
          <i class="fal fa-times"></i>
        </button>
      </div>
      <div class="popup-image" :style="'background-image: url(' + backgroundImage + ')'"></div>
      <div class="popup-message">
        <h2>Please don't go yet!</h2>
        <p>Just your signature will help save my home.</p>
        <button type="button" class="action-btn" data-close @click="confirm">Ok let's do this!</button>
        <button type="button" class="decline-btn" data-close @click="decline">Sorry I can't help</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "leaf-relief-intent-popup",

  props: {
    image: {
      type: [String, Array],
    },
  },
  computed: {
    backgroundImage() {
      if (typeof this.image === "string") {
        return this.image;
      }

      // If array of images - first image is desktop, second image is mobile
      if (this.image && window.matchMedia("(max-width: 640px)").matches) {
        return this.image[1] || this.image[0];
      }
      if (this.image) {
        return this.image[0];
      }
    }
  },

  mounted() {
    // Override popup overlay color
    this.setOverlayBg("transparent");
  },
  methods: {
    confirm() {
      this.$store.dispatch("logPopupActioned");

      // Revert popup overlay color
      this.setOverlayBg();
    },
    decline() {
      this.$store.dispatch("logPopupDeclined");

      // Revert popup overlay color
      this.setOverlayBg();
    },
    setOverlayBg(color = "") {
      $('.reveal-overlay').css("background-color", color);
    }
  }
};
</script>

<style scoped>
.lr-intent-popup {
  z-index: 101;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: #00000050;
}

.lr-intent-popup button {
  cursor: pointer;
}

.popup-container {
  position: relative;
  display: flex;
  width: 100%;
  min-height: 500px;
  max-width: 765px;
  background: var(--wwfWhite);
  border: solid 10px var(--wwfBlack);
}

.intent-close {
  position: absolute;
  top: 5px;
  right: 10px;
}

.intent-close i {
  font-size: 2rem;
  color: var(--wwfGrey82);
}

.popup-image {
  width: 48%;
  background-position: top center;
  background-size: cover;
}

.popup-message {
  flex: 1;
  margin: auto;
  padding: 2.5rem;
}

.popup-message h2 {
  margin-bottom: 2rem;
  font-size: 3rem;
  line-height: 1;
}

.popup-message p {
  font-size: 2rem;
  font-weight: bold;
  line-height: normal;
}

.action-btn {
  display: block;
  margin: 2rem 0;
  padding: 0.5rem 3rem 0.8rem;
  font-family: "WWFRegular",sans-serif;
  font-size: 2rem;
  color: var(--wwfWhite);
  text-transform: uppercase;
  background: var(--wwfOrange);
  border-radius: 7px;
}

.decline-btn {
  display: block;
  font-size: 1.2rem;
  font-weight: bold;
  color: var(--wwfGrey82);
}

@media(max-width: 640px) {
  .popup-container {
    flex-direction: column;
    min-height: unset;
    padding: 2.5rem;
  }

  .popup-message h2 {
    margin-bottom: 1rem;
    font-size: 2rem;
  }

  .action-btn,
  .popup-message p {
    font-size: 1.2rem;
  }

  .decline-btn {
    font-size: 1rem;
    margin: 0 auto;
  }

  .popup-image {
    width: 100%;
    height: 200px;
  }

  .popup-message {
    padding: 1rem 0 0;
    text-align: center;
  }

  .action-btn {
    margin: 1rem auto;
  }
}
</style>


// WEBPACK FOOTER //
// IntentPopup.vue?3b79aa81